module.exports = __webpack_public_path__ + "static/media/tk.9dde06ff.png";